<script setup lang="ts">
const props = defineProps<{
  url: string
}>()

const { data } = await useFetch<string>('/api/video/get-thumbnail', {
  key: `video-thumbnail-${props.url}`,
  params: {
    url: props.url,
  },
  default(): string {
    return ''
  },
})

const src = computed(() => {
  return data.value ?? '/images/default-video-thumbnail.png'
})
</script>

<template>
  <ImageCover :src="src" class="aspect-video flex items-center justify-center">
    <slot />
  </ImageCover>
</template>
